function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { navigationURL } from './endpoints';

function NavigationService(_ref) {
  var access_token = _ref.access_token;

  var fetchWithAuth = function fetchWithAuth(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options = _objectSpread(_objectSpread({}, options), {}, {
      headers: _objectSpread(_objectSpread({}, options.headers || {}), {}, {
        'authorization': "Bearer ".concat(access_token)
      })
    });
    return fetch(url, options);
  };

  function getMenu(_x) {
    return _getMenu.apply(this, arguments);
  }

  function _getMenu() {
    _getMenu = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
      var res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchWithAuth("".concat(navigationURL, "/menus/").concat(encodeURIComponent(type), "/person"));

            case 2:
              res = _context.sent;
              _context.next = 5;
              return res.json();

            case 5:
              data = _context.sent;

              if (!res.ok) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", data);

            case 10:
              throw data;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getMenu.apply(this, arguments);
  }

  return {
    getMenu: getMenu
  };
}

export default NavigationService;
//# sourceMappingURL=navigation-service.js.map